import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
} from '@/components/ui';

interface TerminateConfirmationProps {
  subscriptionId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason?: string) => void;
  isPending: boolean;
}

/**
 * Spec 0222 D1: Reason-Feld entfernt — die Facade nimmt kein reason an und
 * liefert keines zurueck; das Feld suggerierte eine Persistenz, die nicht
 * existiert. Das BFF-Schema akzeptiert reason weiterhin (no-op), daher bleibt
 * die onConfirm-Signatur kompatibel.
 */
export function TerminateConfirmation({
  subscriptionId,
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: TerminateConfirmationProps) {
  const { t } = useTranslation('subscriptions');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('terminate.title')}</DialogTitle>
          <DialogDescription>
            {t('terminate.confirm', { subscriptionId })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            {t('terminate.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={() => onConfirm()}
            disabled={isPending}
          >
            {t('terminate.submit')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
